export const msalClientID = process.env.VUE_APP_MSAL_CLIENT_ID;
export const msalLoginAuthority = process.env.VUE_APP_MSAL_LOGIN_AUTHORITY;
export const adminStageApiUrl = process.env.VUE_APP_ADMIN_API_STAGE;
export const adminProdApiUrl = process.env.VUE_APP_ADMIN_API_PROD;
export const aarpBlob = process.env.VUE_APP_AARP_BLOB;
export const currentAdminEnv = process.env.NODE_ENV;
export const gamesApiUrl = process.env.VUE_APP_GAMES_API;
export const gamesFeedIdStage = process.env.VUE_APP_GAMES_FEED_ID_STAGE;
export const gamesFeedIdProd = process.env.VUE_APP_GAMES_FEED_ID_PROD;

export const AppConfig = {
  msalClientID,
  msalLoginAuthority,
  adminStageApiUrl,
  adminProdApiUrl,
  aarpBlob,
  currentAdminEnv,
  gamesApiUrl,
  gamesFeedIdStage,
  gamesFeedIdProd,
};
